"use client";

import { Children } from "@/types/types";
import { usePathname } from "next/navigation";
import { createContext, useEffect, useState } from "react";

interface MenuContextProps {
  isMenuOpen: boolean | undefined;
  toggleMenu: () => void;
  openMenu: () => void;
  closeMenu: () => void;
}

const MenuContextInit = {
  isMenuOpen: false,
  toggleMenu: () => {},
  openMenu: () => {},
  closeMenu: () => {},
};

interface MenuProviderProps {
  children: Children;
}

export const MenuContext = createContext<MenuContextProps>(MenuContextInit);

function MenuProvider({ children }: MenuProviderProps) {
  const pathname = usePathname();

  const [isMenuOpen, setMenuOpen] = useState<boolean | undefined>(undefined);

  const openMenu = () => {
    setMenuOpen(true);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  return (
    <MenuContext.Provider
      value={{
        isMenuOpen,
        toggleMenu: () => setMenuOpen(!isMenuOpen),
        openMenu,
        closeMenu,
      }}
    >
      {children}
    </MenuContext.Provider>
  );
}

export default MenuProvider;
